//* 组件库
import type { UiTypes, UiTableOption2 } from "various-ui";
//* 组件属性
import type { ModuleDrug, ModuleData } from "../index";

export const useComposable = () => {
    //* 获取i18n
    const i18n = useI18n();

    //* 获取route
    const route = useRoute();

    //* 表格配置项
    const option: UiTableOption2[] = [
        { key: "name", name: i18n.t("Layout.TypeName", { type: "Drug", count: 2 }), align: "singularity" },
        { key: "cas", name: i18n.t("CasNumber"), align: "singularity" },
        { key: "status", name: i18n.t("DrugStatus"), align: "singularity" },
        { key: "phases", name: i18n.t("Phase"), align: "singularity" },
        { key: "src", name: i18n.t("Link"), align: "center" },
    ];

    //* 响应式变量
    const refs = {
        //* 选择器配置
        phases_details: ref<string>(""),
        status_details: ref<string>(""),

        //* 关键词搜索配置
        keyword: ref<string>(""),

        //* 页面数据
        data: ref<ModuleDrug[]>([]),
        page: ref<number>(1),
        count: ref<number>(0),
        phases: ref<UiTypes.candidate[]>([]),
        status: ref<UiTypes.candidate[]>([]),

        //* 页面状态配置
        exist: ref<boolean>(true),
        loading: ref<boolean>(true),
    };

    //* 节点
    const nodes = {
        container: ref<HTMLDivElement>(),
    };

    //* 静态变量
    const variable = { keyword: "" };

    //* 函数列表
    const methods = {
        //* 渲染函数
        render: (data: ModuleData) => {
            //* 数据初始化
            refs.data.value = data.data;
            refs.count.value = data.count;
            refs.loading.value = false;
            refs.phases.value = data.phase;
            refs.status.value = data.status;
        },

        //* 隐藏函数
        hidden: () => {
            refs.exist.value = false;
            refs.loading.value = false;
        },

        //* 搜索函数
        search: () => {
            const keyword = refs.keyword.value.trim();
            if (!refs.loading.value) {
                //* 数据更新
                variable.keyword = keyword;
                //* 接口请求
                methods.acquire(1);
            }
        },

        //* 数据获取
        acquire: (number?: number) => {
            //* 数据更新
            refs.loading.value = true;
            refs.page.value = number || refs.page.value;
            //* 接口请求
            api.frontend(`/api/related/drugs`, {
                data: {
                    id: route.params.id,
                    mode: "gene",
                    page: refs.page.value,
                    status: refs.status_details.value,
                    phases: refs.phases_details.value,
                    keyword: variable.keyword,
                },
                success: (response) => {
                    refs.data.value = response?.data || [];
                    refs.count.value = response?.count || 0;
                    //* 位置移动
                    if (nodes.container.value && scrollTo) {
                        scrollTo({ top: nodes.container.value.offsetTop - 200, behavior: "smooth" });
                    }
                },
                finally: () => {
                    refs.loading.value = false;
                },
            });
        },
    };

    return { refs, nodes, option, methods };
};
